import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  IconButton,
  Box,
  Typography,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import NotificationSnackbar from "./NotificationBar";
function AddnewCertificate({ open, onClose, onSaveSuccess }) {
  const theme = useTheme();
  const [form, setForm] = useState({
    certificate: "",
    certificateField: null,
  });
  const [certificateFields, setCertificateFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const handleSnackbarClose = () => setSnackbarOpen(false);

  useEffect(() => {
    if (open) {
      fetchCertificateFields();
    }
  }, [open]);

  const fetchCertificateFields = async () => {
    try {
      setLoading(true);
      const res = await fetch("/api/support/certficate-fields");
      const data = await res.json();
      setCertificateFields(data || []);
    } catch (error) {
      console.error("Failed to fetch certificate fields", error);
      setSnackbarMessage("Failed to load certificate fields");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, certificate: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.certificate || !form.certificateField?.id) return;

    try {
      const res = await fetch("/api/support/insert-certificate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          certificate: form.certificate,
          certificateFieldId: form.certificateField.id,
        }),
      });
      let data;
      try {
        data = await res.json();
      } catch {
        throw new Error("Server did not return valid JSON");
      }
      if (!res.ok) {
        throw new Error(data?.message || "Server error occurred");
      }
      setSnackbarMessage(data?.message || "Certificate added successfully");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setForm({ certificate: "", certificateField: null });

      setTimeout(() => {
        onSaveSuccess();
        onClose();
      }, 3000);
    } catch (error) {
      console.error("Submit error:", error);
      setSnackbarMessage(error.message || "Something went wrong");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": { borderRadius: 3 },
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: theme.palette.primary.main,
          color: "white",
          fontWeight: 600,
          py: 2,
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight={700}>
            Add New Certificate
          </Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Certificate"
                name="certificate"
                value={form.certificate}
                onChange={handleChange}
                autoFocus
                placeholder="e.g. Professional Certification in Project Management"
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                options={certificateFields}
                value={form.certificateField}
                onChange={(e, newValue) =>
                  setForm({ ...form, certificateField: newValue })
                }
                getOptionLabel={(option) => option?.CertificateField || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Certificate Field"
                    placeholder="Type to search certificate field..."
                  />
                )}
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!form.certificate || !form.certificateField}
        >
          Save Certificate
        </Button>
      </DialogActions>
      <NotificationSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Dialog>
  );
}
export default AddnewCertificate;